module.exports = __webpack_public_path__ + "img/icomoon.4f204ca0.svg";